import { useRangeAuditResults } from '../useRangeAuditResults';
import { AdOverlayMarker } from './AdOverlayMarker';
import { AuditMatchMarker } from './AuditMatchMarker';
import { DiarizationMarker } from './DiarizationMarker';
import { AuditMentionMarker } from './mentions/AuditMentionMarker';

export function AuditFocusMarkers() {
  const { data } = useRangeAuditResults();

  return (
    <>
      {data.matches.map((match, index) => (
        <AuditMatchMarker key={index} match={match} />
      ))}

      {data.liveMentions.map((liveMention, index) => (
        <AuditMentionMarker key={index} liveMention={liveMention} />
      ))}

      {data?.diarizations?.map((diarization, index) => (
        <DiarizationMarker key={index} diarization={diarization} />
      ))}
      {data?.adoverlays?.map((adoverlay, index) => {
        return <AdOverlayMarker key={index} adOverlay={adoverlay} />;
      })}
    </>
  );
}
